import { useModeContext } from 'canoe';
import React from 'react';

import { PositionBox, PositionBoxLabel } from './PositionBox';

interface Props {
  selectorComponent: JSX.Element;
  label?: string;
}

export const PositionSelector = ({ selectorComponent, label }: Props) => {
  const { mode } = useModeContext();

  return (
    <PositionBox mode={mode}>
      {selectorComponent}
      {label && <PositionBoxLabel mode={mode}>{label}</PositionBoxLabel>}
    </PositionBox>
  );
};
